import { Skeleton } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type { WithIdProps } from "@src/components/HOC/with-id/withId";
import { NavBar } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { useQuoteNavigationPages } from "@src/components/widgets/AppSubNav/navigation-quote/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";

export const NavigationQuote = ({ id }: WithIdProps) => {
  const { visiblePages, isLoading, data } = useQuoteNavigationPages(id);
  const { isDesktop } = useScreenType();

  return (
    <AppSubNav>
      {visiblePages.map((page) => (
        <NavBar.Item key={page.href.pathname} href={page.href}>
          {page.title()}
        </NavBar.Item>
      ))}

      {isDesktop && <Icon name="chevron-right" />}

      <NavBar.Item
        href={{
          pathname: "/budgets/edit-quote",
          query: { id },
        }}
        active={false}
      >
        <Skeleton isLoaded={!isLoading}>
          {data?.number ?? <Trans>Edit</Trans>}
        </Skeleton>
      </NavBar.Item>
    </AppSubNav>
  );
};
